

























import { RETRY_SEND_MSG } from '@/const/eventBus';
import { defineComponent, ref } from '@vue/composition-api';
export default defineComponent({
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    content: {
      type: String,
      default: '',
    },
    showDialog: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { root, emit }: any) {
    const curSelected = ref(-1);
    props.value.forEach((item: any, index) => {
      if (item.selectStatus === 'yes') {
        return (curSelected.value = index);
      }
    });
    const selectRow = (index, row) => {
      curSelected.value = index;
      console.log(row);
    };

    const onClickClose = () => {
      emit('click-close');
    };

    const onClickConfirm = () => {
      if (curSelected.value < 0) {
        return root.$toast('未选择消息');
      }
      emit('click-confirm', props.value[curSelected.value]);
    };

    root.$emitter.on(RETRY_SEND_MSG, () => {
      emit('update:value', '');
    });

    return {
      curSelected,
      onClickClose,
      onClickConfirm,
      selectRow,
    };
  },
});
